
window.addEventListener('scroll', function () {
    const header = document.getElementById('header');
    if (header) {
        if (window.scrollY > 50) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }
    }

    updateActiveNavLink();
});

function updateActiveNavLink() {
    const sections = document.querySelectorAll('section');
    const navLinks = document.querySelectorAll('.nav-links a');
    const logo = document.querySelector('.logo');

    let currentSection = 'hero';

    sections.forEach(section => {
        const sectionTop = section.offsetTop - 200;
        if (window.scrollY >= sectionTop) {
            currentSection = section.getAttribute('id') || 'hero';
        }
    });

    if (window.scrollY < 200) {
        currentSection = 'hero';
    }

    navLinks.forEach(link => {
        link.classList.remove('active');
        if (link.getAttribute('href') === `#${currentSection}`) {
            link.classList.add('active');
        }
    });

    if (currentSection === 'hero' && logo) {
        logo.classList.add('active');
    } else if (logo) {
        logo.classList.remove('active');
    }
}

const handleSmoothScroll = (e) => {
    const targetId = e.currentTarget.getAttribute('href');
    if (targetId && targetId.startsWith('#')) {
        e.preventDefault();
        const targetElement = document.querySelector(targetId);
        if (targetElement) {
            window.scrollTo({
                top: targetElement.offsetTop - 80,
                behavior: 'smooth'
            });
        }
    }
};


document.addEventListener('DOMContentLoaded', function() {

    document.querySelectorAll('.nav-links a').forEach(anchor => {
        anchor.addEventListener('click', handleSmoothScroll);
    });

    updateActiveNavLink();

    const skillCards = document.querySelectorAll('.skill-card');
    skillCards.forEach(card => {
        const rect = card.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom >= 0) {
            const skillBar = card.querySelector('.skill-progress');
            if (skillBar) {
                const width = skillBar.getAttribute('data-width');
                if (width) {
                    setTimeout(() => {
                        skillBar.style.width = width + '%';
                    }, 200);
                }
            }
        }
    });
});


document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.btn').forEach(button => {
        button.addEventListener('click', function (e) {
            if (this && this.getAttribute('type') !== 'submit' && !this.closest('.hero-btns')) {
                const originalText = this.innerHTML;
                this.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Loading...';
                this.classList.add('loading');

                setTimeout(() => {
                    this.innerHTML = originalText;
                    this.classList.remove('loading');
                }, 1500);
            }
        });
    });
});


export { handleSmoothScroll, updateActiveNavLink };